import React from 'react';
import clsx from 'clsx';
import classes from './SurveyTip.module.scss';
import PageMetaData from 'components/atoms/PageMetaData/PageMetaData';
import { SurveyTip as SurveyTipInterface } from 'constants/QmeeSurveyTips';
import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import OinqTip from 'components/assets/oinq/oinqtip.svg';
import { SURVEY_TIPS } from 'components/pages/pages';
import BackButton from 'components/atoms/BackButton/BackButton';
import Heading from 'components/atoms/Heading/Heading';
import Card from 'components/atoms/Card/Card';

export interface Props {
  surveyTips: SurveyTipInterface[];
  surveyTipIndex: number;
}

const SurveyTip: React.FC<Props> = ({ surveyTips, surveyTipIndex }) => {
  // const translate = useTranslate();
  const { title, description, advice } = surveyTips[surveyTipIndex];

  return (
    <div className={classes.root}>
      <PageMetaData
        metaData={{
          title: `Survey Tip ${surveyTipIndex + 1} - ${title}`,
          description: description.split('\n')[0],
          imageUrl:
            'https://cdn.assets.qmee.com/colour-scheme/survey-tips/banners/SocialShareBanner.png',
          isTranslated: true,
        }}
      />

      <div className={classes.backButtonWrapper}>
        <BackButton to={SURVEY_TIPS.path} />
      </div>

      <div className={classes.tipWrapper}>
        <nav className={classes.tipNav}>
          <ul className={classes.tipNavList}>
            {surveyTips.map((tip, tipIndex) => (
              <li key={tip.path}>
                <A
                  href={`${SURVEY_TIPS.path}/${tip.path}`}
                  className={clsx(classes.tipNavListLink, {
                    [classes.activeLink]: tipIndex === surveyTipIndex,
                  })}
                >
                  <Txt component="span" translateOptions={{ vars: [tipIndex + 1] }}>
                    Tip {{ tipIndex: tipIndex + 1 }}
                  </Txt>
                  <Txt>{tip.title}</Txt>
                </A>
              </li>
            ))}
          </ul>
        </nav>

        <main className={classes.tipContent}>
          <section>
            <Txt
              component="p"
              className={classes.tipSubHeading}
              translateOptions={{ vars: [surveyTipIndex + 1] }}
            >
              Tip {{ tipIndex: surveyTipIndex + 1 }}
            </Txt>
            <Heading level={1} className={classes.tipTitle}>
              {title}
            </Heading>
            <Txt asMarkdown>{description}</Txt>

            <aside className={classes.tipAdvice}>
              <Card className={classes.tipAdviceText}>
                <Heading level={2} className={classes.tipAdviceTitle}>
                  <Txt>Oinq&apos;s Advice</Txt>...
                </Heading>
                <blockquote>
                  <Txt asMarkdown>{`**&ldquo;**&nbsp;${advice.quote}&nbsp;**&rdquo;**`}</Txt>
                </blockquote>
                <Txt asMarkdown className={classes.tipAdviceDescription}>
                  {advice.description}
                </Txt>
              </Card>
              <OinqTip className={classes.tipAdviceImg} />
            </aside>
          </section>
        </main>
      </div>
    </div>
  );
};
export default SurveyTip;
